import type { ReactNode } from "react";
import { CadDialog } from "../features/cad/CadDialog";
import { CadFormContext } from "./formContext";

/**
 * Modal — CAD iletişim penceresi (README §4.7): overlay + 26 px başlık çubuğu; gövdede kâğıt başlıkları (h2) kategori bandına, düğmeler CAD stiline döner.
 * `label` başlık çubuğu metni ve erişilebilir ad; `width` px (Künye 560, Paylaş 520, Geçmiş 640, Çakışma 480, Poz 1000); `tone` uyarı/hata bandı.
 */
export function Dialog({ open, onClose, label, children, width = 520, tone, footer }: { open: boolean; onClose: () => void; label: string; children: ReactNode; className?: string; width?: number; tone?: "warn" | "error"; footer?: ReactNode }): JSX.Element | null {
  if (!open) return null;
  return (
    <CadDialog open onClose={onClose} title={label} width={width} tone={tone} footer={footer ? <CadFormContext.Provider value={true}>{footer}</CadFormContext.Provider> : undefined}>
      <CadFormContext.Provider value={true}><div className="cad-options cad-dialog-body grid gap-2 text-[12px]">{children}</div></CadFormContext.Provider>
    </CadDialog>
  );
}
